// extracted by mini-css-extract-plugin
export default {"frame":"recentes_frame__EBHBH","frameSquare":"recentes_frameSquare__mGW9j","imagem":"recentes_imagem__Vg3xu","marca":"recentes_marca__nZOoQ","modelo":"recentes_modelo__ca1+9"};